import { sanitize } from 'isomorphic-dompurify';

import { type IV1GetMainPageBrandBannerEnrichmentsResponse } from 'shared/repositories/ad-banner/entities/get_main_page_brand_banner_enrichments_v1/V1GetMainPageBrandBannerEnrichmentsResponse';
import { type TAdfoxBannerCompleteSizes } from 'shared/types/adfox';
import { type TMainpageBrandContext } from 'shared/types/bannerContext';

const DEFAULT_BUTTON_TEXT = 'Узнать цены';

type TGetMainpageBrandCompleteContextOptions = {
  context: TMainpageBrandContext;
  sizes: TAdfoxBannerCompleteSizes;
  enrichments: IV1GetMainPageBrandBannerEnrichmentsResponse | null;
};

export type TGetMainpageBrandCompleteContextResult = {
  sizes: TAdfoxBannerCompleteSizes;
  url: string;
  bgImageUrl: string;
  logoImageUrl: string;
  substrateNotNeeded: boolean;
  buttonText: string;
  label: string | undefined;
  note: string | undefined;
  sanitizedName: string | undefined;
  sanitizedInfo: string | undefined;
  sanitizedActionText: string | undefined;
  sanitizedPhone: string | undefined;
  mortgageWarning: string | undefined;
  mortgageTermsWarning: string | undefined;
};

export function getMainpageBrandCompleteContext({
  sizes,
  enrichments,
  context: {
    url,
    bgImageUrl,
    logoImageUrl,
    substrateNotNeeded,
    name,
    info,
    actionText,
    phone,
    buttonText,
    note,
    label,
    mortgageTermsWarning,
    mortgageWarning,
  },
}: TGetMainpageBrandCompleteContextOptions): TGetMainpageBrandCompleteContextResult {
  const completeContext: TGetMainpageBrandCompleteContextResult = {
    bgImageUrl,
    buttonText: buttonText || DEFAULT_BUTTON_TEXT,
    label,
    logoImageUrl,
    mortgageTermsWarning,
    mortgageWarning,
    note,
    sanitizedActionText: actionText ? sanitize(actionText) : undefined,
    sanitizedInfo: info ? sanitize(info) : undefined,
    sanitizedName: name ? sanitize(name) : undefined,
    sanitizedPhone: phone ? sanitize(phone) : undefined,
    sizes,
    substrateNotNeeded: substrateNotNeeded === '1',
    url,
  };

  if (enrichments) {
    Object.assign<TGetMainpageBrandCompleteContextResult, Partial<TGetMainpageBrandCompleteContextResult>>(
      completeContext,
      {
        // Серверное обогащение переопределяет info заголовком баннера для главной; пустой заголовок не затирает контекст Adfox.
        sanitizedInfo: enrichments.title ? sanitize(enrichments.title) : completeContext.sanitizedInfo,
      },
    );
  }

  return completeContext;
}
